import { useEffect, useState } from "react";
import _ from "lodash";

import { Form, Checkbox, Col, Row, Radio } from "antd";
import { GKPresetColors } from "../../../MediaLibrary/EditModal/LeftSidebar/EditTab";

export const InputCheckboxSingle = (props) => {
    const { item, form, templateData, setTemplateData } = props;

    if (item.data) {
        item.data.sort((a, b) => a.shirtNumber - b.shirtNumber);
    }

    const [selectedValues, setSelectedValues] = useState(item.defaultValue || "");
    const handleChange = (checkedValues) => {
        const lastValue = checkedValues[checkedValues.length - 1];
        setSelectedValues(lastValue ? lastValue : "");
        const updatedTemplateData = _.cloneDeep(templateData);
        const index = updatedTemplateData.data.fields.findIndex(f => f.id === 'heatmap_players');
        if (index !== -1) {
            _.set(updatedTemplateData, `data.fields[${index}].value`, lastValue);
        }
        setTemplateData(updatedTemplateData)
        form?.setFieldsValue({
            [item.id]: lastValue,
        });
    };

    useEffect(() => {
        if (["heatmap_players",].includes(item.id)) {
            const currentValues = form.getFieldValue(item.id) || [];
            setSelectedValues(currentValues);
        }
    }, [item.id]);

    return (
        <>
            <span style={{fontSize: 22, fontWeight: 'bold', marginBottom: 8}}>Select Player</span>
            <Form.Item
                // label={item.label}
                name={item?.id}
                rules={[{ required: false, message: "Please input your username!" }]}
                tooltip={props.tooltip}
                style={props?.style}
                initialValue={item.defaultValue || ""}
            >
                <Checkbox.Group
                    style={{
                        width: "100%",
                    }}
                    value={selectedValues}
                    onChange={handleChange}
                >
                    {(
                        <Row style={{ display: 'flex' }}>
                            {

                                <>
                                    <Col span={12}>
                                        {
                                            item.data?.slice(0, Math.ceil(item.data.length / 2)).map((element, index) => (
                                                <Checkbox
                                                    key={index}
                                                    value={element.id}
                                                >
                                                    <div style={{ display: "flex", fontSize: 20 }}>
                                                        <span
                                                            style={{
                                                                width: 25,
                                                                textAlign: "center",
                                                                marginRight: 3,
                                                            }}
                                                        >
                                                            {element.shirtNumber}
                                                        </span>
                                                        <span
                                                            style={{
                                                                width: 150,
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                        >
                                                            {element.shortLastName}
                                                        </span>
                                                    </div>
                                                </Checkbox>
                                            ))}
                                    </Col>

                                    <Col span={12}>
                                        {
                                            item.data?.slice(Math.ceil(item.data.length / 2)).map((element, index) => (
                                                <Checkbox
                                                    key={index}
                                                    value={element.id}
                                                >
                                                    <div style={{ display: "flex", fontSize: 20 }}>
                                                        <span
                                                            style={{
                                                                width: 25,
                                                                textAlign: "center",
                                                                marginRight: 3,
                                                            }}
                                                        >
                                                            {element.shirtNumber}
                                                        </span>
                                                        <span
                                                            style={{
                                                                width: 150,
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                        >
                                                            {element.shortLastName}
                                                        </span>
                                                    </div>
                                                </Checkbox>
                                            ))}
                                    </Col>
                                </>
                            }
                        </Row>
                    )}
                </Checkbox.Group>
            </Form.Item>
        </>
    );
};
